import { BASE_BPM, MAX_LEVEL } from "./constants";
import type { LevelConfig } from "./types";
import {
  LEVEL_DOOM_CLOCK_CAPS,
  LEVEL_ROTATION_SECONDS,
  LEVEL_SCORE_TARGETS,
  VERSUS_LEVEL_SCORE_TARGETS,
  LEVEL_TILE_TYPES,
  obstaclePercentsForLevel,
  scrambleOpsForLevel
} from "./tuning";

export function rotationSecondsForLevel(level: number): number {
  const clamped = Math.min(MAX_LEVEL, Math.max(1, Math.floor(level)));
  return LEVEL_ROTATION_SECONDS[clamped - 1];
}

export function doomClockCapForLevel(level: number): number {
  const clamped = Math.min(MAX_LEVEL, Math.max(1, Math.floor(level)));
  return LEVEL_DOOM_CLOCK_CAPS[clamped - 1];
}

export function scoreTargetForLevel(level: number): number {
  const clamped = Math.min(MAX_LEVEL, Math.max(1, Math.floor(level)));
  return LEVEL_SCORE_TARGETS[clamped - 1];
}

export function versusScoreTargetForLevel(level: number): number {
  const clamped = Math.min(MAX_LEVEL, Math.max(1, Math.floor(level)));
  return VERSUS_LEVEL_SCORE_TARGETS[clamped - 1];
}

export const LEVELS: LevelConfig[] = Array.from({ length: MAX_LEVEL }, (_, idx) => {
  const level = idx + 1;
  const obstaclePct = obstaclePercentsForLevel(level);
  return {
    level,
    scoreTarget: scoreTargetForLevel(level),
    tileTypes: LEVEL_TILE_TYPES[idx],
    rotationEveryBeats: rotationSecondsForLevel(level) * (BASE_BPM / 60),
    scrambleOps: scrambleOpsForLevel(level),
    cratePct: obstaclePct.cratePct,
    lockPct: obstaclePct.lockPct,
    steelPct: obstaclePct.steelPct
  };
});

export function getLevelConfig(level: number): LevelConfig {
  const clamped = Math.min(MAX_LEVEL, Math.max(1, level));
  return LEVELS[clamped - 1];
}

export function colorWeights(tileTypes: number): number[] {
  const weights: number[] = [];
  for (let c = 0; c < tileTypes; c += 1) {
    weights.push(c < 4 ? 1.25 : 1);
  }
  return weights;
}
